import { UploadedFile } from "@/components/FileUploadZone";
import api from "./axios-service";
import axios from "axios";
import { AxiosProgressEvent } from "axios";

type SignedFileResponse = {
  key: string;
  signedUrl: string;
};

export async function uploadFiles(
  files: File[],
  folder: string,
  setProgress: (progress: number, name: string) => void
) {
  const promises = files.map((file): Promise<UploadedFile> => {
    return new Promise((resolve, reject) => {
      // Get presigned URLs for upload
      api
        .post<SignedFileResponse>("/upload/prepare", {
          folder,
          name: file.name,
          size: file.size,
          type: file.type,
        })
        .then(({ data: result }) => {
          axios
            .put(result.signedUrl, file, {
              headers: {
                "Content-Type": file.type,
              },
              onUploadProgress: (progressEvent: AxiosProgressEvent) => {
                const progress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
                setProgress(progress, file.name);
              },
            })
            .then(() => {
              resolve({
                key: result.key,
                name: file.name,
                size: file.size,
                type: file.type,
              });
            })
            .catch(reject);
        })
        .catch(reject);
    });
  });

  return await Promise.all(promises);
}

export function makeFileUrl(
  key: string,
  attach = false,
  encode = false,
  fileName = ""
) {
  let url = `${
    import.meta.env.VITE_API_URL
  }/file/${key}?attachment=${attach}&fileName=${
    fileName ? encodeURIComponent(fileName) : ""
  }`;
  if (encode) {
    url = encodeURIComponent(url);
  }
  return url;
}
